import {useCallback, useEffect, useRef, useState} from 'react';
import {MainPageLocationMode} from '@/app/interfaces/preferences';
import {
	checkGeoPermissionAllowed,
	getGeoPermission,
	isGeolocationPermissionOnce,
} from '@/common/helpers/geolocation/geolocationHelper';

export const useGeoPermission = (mainPageLocationMode?: MainPageLocationMode) => {
	const [shown, setShown] = useState(false);

	const handleClose = useCallback(() => {
		setShown(false);
	}, []);

	// Show the ask popup when user do not allow or deni access before
	const wasCheckedRef = useRef(false);
	useEffect(() => {
		// Ignore when full config did not loaded
		if (!mainPageLocationMode || wasCheckedRef.current) {
			return;
		}

		// Ignore if permission grants only for current session (Safari iOS case)
		if (isGeolocationPermissionOnce()) {
			return;
		}

		wasCheckedRef.current = true;
		if (mainPageLocationMode !== 'determine' || !checkGeoPermissionAllowed()) {
			return;
		}

		const ignoreRecord = localStorage.getItem('sinoptik:ignoreGeolocationRequestUntil');
		if (ignoreRecord && Number(ignoreRecord) > Date.now()) {
			return;
		}

		getGeoPermission().then(permission => {
			// Show the popup after a timeout so that it is not considered Largest Contentful Paint (Web Vitals)
			setTimeout(() => {
				if (permission.state === 'prompt') {
					setShown(true);
				}
			}, 10000);

			// Hide when geolocation permission was changed from another place
			permission.onchange = () => {
				if (permission.state !== 'prompt') {
					setShown(false);
				}
			};
		});
	}, [mainPageLocationMode]);

	return {shown, handleClose};
};

useGeoPermission.displayName = 'useGeoPermission';
